import { render, staticRenderFns } from "./summary_indicator_patents.vue?vue&type=template&id=90fdad90"
import script from "./summary_indicator_patents.vue?vue&type=script&lang=js"
export * from "./summary_indicator_patents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports